import { Localize } from '@kokolingo/localisation';

export default Localize;
